export default __webpack_public_path__ + "static/media/src_img_11.19b61c5b.jpg";